import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  create: 'Customize your workspace',
  submit: 'Continue to workspace',
  nameTitle: 'Workspace name',
  nameSubtitle:
    'The name you choose will be visible to all users within your workspace',
  imageTitle: 'Workspace logo',
  typeTitle: 'Workspace type',
  typeSubtitle:
    "Please select the category that most closely fits your workspace's type",
};

const welsh = {
  create: 'Creu gweithle',
  submit: "Parhewh i'r gweithle",
  nameTitle: 'Enw gweithle',
  nameSubtitle:
    'Bydd yr enw a ddewiswch yn weladwy i bob defnyddiwr o fewn eich sefydliad',
  imageTitle: 'Logo gweithle',
  typeTitle: 'Math o le gwaith',
  typeSubtitle: 'Dewiswch y categori sy’n cyd-fynd orau â math eich sefydliad',
};

export const createOrgText = getLocalizationBasedOnLang(english, welsh);
